import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Logo } from '../../components/shared';

const SessionTimeout = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  return (
    <div className="container-md vh-md-100 d-flex flex-column align-items-center w-100">
      {/* browser only */}
      <div className="d-none d-md-flex row" style={{ paddingTop: '4rem', paddingBottom: '2rem' }}>
        <Logo />
      </div>

      <div className="d-none d-md-flex row" style={{ paddingTop: '4rem', paddingBottom: '2rem' }}>
        <></>
      </div>

      {/* mobile layout */}
      <div className="d-flex d-md-none bg-light align-items-center card position-relative">
        <img
          style={{
            width: '30%',
            marginTop: '7rem',
          }}
          src="./assets/images/timeout.svg"
          alt="warning"
        />
        <div className="text-f5 p-4">
          <p className="text-center text-info">{translate('please_login_again')}</p>
          <p className="text-center mt-4">{translate('session_timeout_subtitle')}</p>
        </div>
      </div>

      {/* browser layout */}
      <div className="d-none d-md-flex bg-lighter col-5 align-items-center card position-relative">
        <img
          style={{
            width: '30%',
            marginTop: '7rem',
          }}
          src="./assets/images/timeout.svg"
          alt="warning"
        />
        <div className="text-f5 p-4">
          <p className="text-center text-info">{translate('please_login_again')}</p>
          <p className="text-center mt-4">{translate('session_timeout_subtitle')}</p>
        </div>
        <div className="row d-flex justify-content-center w-70 mb-5">
          <button
            type="button"
            className="btn py-3 btn-primary my-5"
            onClick={() => {
              history.push('/onboarding/login');
            }}>
            {translate('signin_link_label')}
          </button>
        </div>
      </div>

      {/* mobile only */}
      <div className="d-flex d-md-none flex-row fixed-bottom mb-4 justify-content-center w-100 ">
        <button
          type="button"
          className="btn btn-primary w-70"
          onClick={() => {
            history.push('/onboarding/login');
          }}>
          {translate('signin_link_label')}
        </button>
      </div>
    </div>
  );
};

export default SessionTimeout;
